import React from 'react'
import { ButtonGroup, Button } from 'react-bootstrap'

const ButtonSelector = ({
    options = [],
    value,
    onChange = () => {}
}) => {
    const renderMode = (mode, key) => {
        return (
            <Button
                key={key}
                variant={value === mode ? 'primary' : 'outline-primary'}
                onClick={() => onChange(mode)}
            >
                {mode.toUpperCase()}
            </Button>
        )
    }
    return (
        <ButtonGroup>
            {options.map(renderMode)}
        </ButtonGroup>
    )
}

export default ButtonSelector
